/**
 * 스토리 테스트 화면 문구 (기본값).
 * 테스트 데이터의 texts: { 키: "문구" } 로 덮어쓸 수 있어요. 편집기 '화면 문구'에서 고치면 됩니다.
 * {n} {total} {name} 같은 자리표시는 화면에서 숫자·이름으로 바뀝니다.
 */
export const TEXTS = {
  // 소개 화면
  introHint: "이어폰을 끼면 더 좋아요",
  startButton: "이야기 시작하기",
  // 플레이 화면
  openingHint: "이어폰을 끼면 더 좋아요.",
  openingTap: "화면을 탭하면 시작합니다",
  chapterTap: "탭하여 계속",
  // 끝 화면 1단계: 공감 고르기
  checkButton: "공감한 {n}개 조각으로 글 추천받기",
  checkHint: "여러 개 골라도 돼요. 고른 만큼 추천 글이 늘어나요.",
  // 끝 화면 2단계: 지도와 추천 글
  mapTitle: "가장 진하게 남은 조각은 {name}",
  mapTitleNone: "아직은 남의 이야기 같았나요",
  mapCount: "공감 {n} / {total}",
  redo: "다시 고르기",
  chipAll: "모두에게",
  more: "이 조각의 글 {n}편 더 보기",
  less: "접기",
  thumbLabel: "촉촉한마케터",
  productsChip: "함께 보면 좋은 것",
  productsTitle: "촉촉한마케터의 책과 도구",
  coupangNote: "이 페이지의 쿠팡 링크는 쿠팡 파트너스 활동의 일환으로, 이에 따른 일정액의 수수료를 제공받습니다.",
  // 맨 아래 저장
  saveEyebrow: "나중에 읽기",
  saveTitle: "추천 글 {n}편, 한 번에 저장하기",
  saveCopyAll: "링크 전체 복사",
  saveNotion: "노션용 체크리스트",
  saveTxt: ".txt 파일로 저장",
  saveLink: "이 결과 링크 복사",
  toastCopyAll: "링크를 전부 복사했어요",
  toastNotion: "노션·메모장에 붙여 넣으면 체크리스트가 돼요",
  toastTxt: "파일로 저장했어요",
  toastLink: "이 페이지 링크를 복사했어요. 언제든 다시 열 수 있어요",
  toastFail: "복사하지 못했어요",
  fileName: "촉촉한마케터_읽을글",
  // 결과 페이지 아래쪽 (공유)
  shareTitle: "공유하기",
  shareCopy: "링크복사",
  shareEtc: "비슷한향",
  retry: "다시하기",
  toastShare: "링크 복사를 완료하였습니다.",
};

/** 문구 꺼내기: tx(test, "checkButton", { n: 3 }) */
export const tx = (test, key, vars = {}) => {
  const s = test?.texts?.[key] ?? TEXTS[key] ?? "";
  return String(s).replace(/\{(\w+)\}/g, (_, k) => (vars[k] ?? `{${k}}`));
};
